//
//
//
//
//
//

import { getElementSize, getRelativePosition } from './dom';

export default {
    name: 'DropdownBox',
    components: {
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            width: 0,
            posTop: 0,
            posLeft: 0,
        }
    },
    watch: {
        visible: {
            immediate: true,
            handler(value) {
                this.$nextTick( () => {
                    if ( value ) {
                        this.display();
                    }
                } );
            }
        }
    },
    methods: {
        handleClickOutside(event) {
            if ( !this.visible ) {
                return;
            }

            const el = this.$el;

            if ( el && !el.contains( event.target ) && !this.$parent.$el.contains( event.target ) ) {
                event.$el = el;

                this.$emit('clickoutside', event );
            }
        },
        display() {
            if ( !this.visible ) {
                return;
            }

            const box = this.$el;
            const parentEl = this.$parent.$el;

            const { width, height } = getElementSize( box );
            const { left, top } = getRelativePosition( parentEl, width, height, true );

            const parent_rect = parentEl.getBoundingClientRect();

            this.posLeft = left;
            this.posTop = top + parent_rect.height + height;
            this.width = parentEl.offsetWidth;
        },
    },
    mounted() {
        document.body.appendChild( this.$el );

        document.addEventListener( 'click', this.handleClickOutside );
    },
}
